<template>
  <div>
    <heads />
    <div class="content">
      <router-view :key="$route.fullPath"/>
    </div>
    <bottom />
  </div>
</template>
<script>
import heads from "../component/home/header";
import bottom from "../component/home/bottom";
export default {
  name: "App",
  components: {
    heads,
    bottom
  },
  data() {
    return {
      url: this.$route.path
    };
  },
  watch: {
    $route(to, from) {
      this.url = this.$route.path;
    }
  },
  created() {},
  methods: {}
};
</script>
<style>
* {
  padding: 0;
  margin: 0;
}

/* body {
    font: 12px Arial, "PingFang SC", "Hiragino Sans GB", STHeiti,
      "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
  } */

a {
  text-decoration: none;
}

.content {
  /* min-height: 1000px; */
  height: auto;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue